import { useCallback, useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import configFile from "config.json";
import axiosCustom from "utils/axios";
import styled from "styled-components";
import { SelectStore } from "components/Form/InputTypes";
import { Button, Checkbox, Divider, Form, Tabs, Tag } from "antd";

const CheckboxGroup = Checkbox.Group;

const ProductCopy = () => {
    const [productList, setProductList] = useState([]);
    const [form] = Form.useForm();
    const [store, setStore] = useState();
    const [stores, setStores] = useState();
    const [tabItem, setTabItem] = useState(null);

    const [checkedFromList, setCheckedFromList] = useState([]);
    const [indeterminateFrom, setIndeterminateFrom] = useState(true);
    const [checkAllFrom, setCheckAllFrom] = useState(false);
    const [checkedToList, setCheckedToList] = useState([]);
    const [indeterminateTo, setIndeterminateTo] = useState(true);
    const [checkAllTo, setCheckAllTo] = useState(false);
    const [products, setProducts] = useState([]);
    
    const createOptionsFromData = useCallback((tabData, tabName) => {
        if (!tabData) return [];

        if (Array.isArray(tabData)) {
            return tabData.map((item, index) => ({
                label: (
                    <div>
                        {item.masterName || item.name || item.majorGroup || 'Unknown'}
                        <Tag color={item.show ? "green" : "volcano"} key={index}>
                            {item.show ? "Харагдана" : "Харагдахгүй"}
                        </Tag>
                    </div>
                ),
                value: item.id || index,
            }));
        }
        
        if (typeof tabData === 'object') {
            const options = [];
            
            Object.entries(tabData).forEach(([key, value]) => {
                if (value.items && Array.isArray(value.items)) {
                    value.items.forEach((pizzaItem, pizzaIndex) => {
                        const pizzaSizeLabel = value.pizzaSize?.[pizzaItem.pizzaSize] || pizzaItem.pizzaSize || '';
                        const pizzaBaseLabel = pizzaItem.pizzaBase || '';
                        const price = pizzaItem.price ? `${pizzaItem.price.toLocaleString()}₮` : '';
                        
                        options.push({
                            label: (
                                <div>
                                    {key} - {pizzaSizeLabel} ({pizzaBaseLabel}) {price}
                                    <Tag color={pizzaItem.show ? "green" : "volcano"} key={`${key}-${pizzaIndex}`}>
                                        {pizzaItem.show ? "Харагдана" : "Харагдахгүй"}
                                    </Tag>
                                </div>
                            ),
                            value: pizzaItem.menuItemDefID || `${key}-${pizzaIndex}`,
                        });
                    });
                } else {
                    options.push({
                        label: (
                            <div>
                                {key}
                                <Tag color={value.show !== false ? "green" : "volcano"} key={key}>
                                    {value.show !== false ? "Харагдана" : "Харагдахгүй"}
                                </Tag>
                            </div>
                        ),
                        value: value.id || key,
                    });
                }
            });
            
            return options;
        }

        return [];
    }, []);

    const fetchData = useCallback(async () => {
        try {
            const {
                data: { data: menus },
            } = await axiosCustom.post(`${configFile.PROD_SERVER_URL}/menu/getMenus`, {
                storeName: store,
            });
            const filteredMenus = JSON.parse(JSON.stringify(menus));
            const keysToRemove = ['Meal', 'Others', 'Sample', 'Side ND', 'Combo ND', 'Dessert ND', 'Beverage ND', 'Combo'];

            keysToRemove.forEach(key => {
                delete filteredMenus[key];
            });

            setProductList(filteredMenus);
        } catch (error) {
            NotificationManager.error(
                error?.response?.data?.errorMessage || "Алдаа гарлаа",
                "Error",
                5000
            );
        }
    }, [store]);
    
    useEffect(() => {
        setCheckedFromList([]);
        setTabItem(null);
        setCheckedToList([]);
        setProducts([]);
        if (store) {
            fetchData();
        }
    }, [store, fetchData]);

    useEffect(() => {
        if (productList && Object.keys(productList).length > 0) {
            const currentTab = tabItem || Object.keys(productList)[0];
            
            if (currentTab && productList[currentTab]) {
                setTabItem(currentTab);
                const tabData = productList[currentTab];
                const options = createOptionsFromData(tabData, currentTab);
                setProducts(options);
            }
        }
    }, [productList, tabItem, createOptionsFromData]);

    const handleStore = (item) => {
        setStore(item);
    };

    const onCheckAllChangeFrom = (e) => {
        setCheckedFromList(
            e.target.checked ? products.map((item) => item.value) : []
        );
        setIndeterminateFrom(false);
        setCheckAllFrom(e.target.checked);
    };

    const onCheckAllChangeTo = (e) => {
        setCheckedToList(e.target.checked ? stores : []);
        setIndeterminateTo(false);
        setCheckAllTo(e.target.checked);
    };

    const onChangeFrom = (list) => {
        setCheckedFromList(list);
        setIndeterminateFrom(!!list.length && list.length < products.length);
        setCheckAllFrom(list.length === products.length);
    };

    const onChangeTo = (list) => {
        setCheckedToList(list);
        setIndeterminateTo(!!list.length && list.length < stores.length);
        setCheckAllTo(list.length === stores.length);
    };

    const onChangeTab = useCallback((newTab) => {
        setTabItem(newTab);
        setCheckedFromList([]);
        
        const tabProducts = productList[newTab];
        if (tabProducts) {
            const options = createOptionsFromData(tabProducts, newTab);
            setProducts(options);
        }
    }, [productList, createOptionsFromData]);

    const handleCopy = async () => {
        const toStores = checkedToList.map((item) => item);
        
        const tabData = productList[tabItem];

        let items = [];
        
        if (Array.isArray(tabData)) {
            items = tabData
                .filter(item => checkedFromList.includes(item.id))
                .map(item => ({
                    menuItemDefID: item.id,
                    show: item.show
                }));
        } else if (typeof tabData === 'object') {
            Object.entries(tabData).forEach(([key, value]) => {
                if (value.items && Array.isArray(value.items)) {
                    value.items.forEach((pizzaItem) => {

                        if (checkedFromList.includes(pizzaItem.menuItemDefID)) {
                            items.push({
                                menuItemDefID: pizzaItem.menuItemDefID,
                                show: pizzaItem.show
                            });
                        }
                    });
                } else {
                    if (checkedFromList.includes(value.id || key)) {
                        items.push({
                            menuItemDefID: value.id || key,
                            show: value.show !== false
                        });
                    }
                }
            });
        }
        
        const fromStore = store;

        try {
            await axiosCustom.post(
                `${configFile.PROD_SERVER_URL}/menu-config/copy`,
                {
                    fromStore,
                    toStores,
                    items,
                }
            );
            NotificationManager.success("Амжилттай хууллаа");
        } catch (error) {
            NotificationManager.error(
                error.response.data.errorMessage,
                "Error",
                5000
            );
            console.log(error);
        }
    };

    return (
        <StyledC>
            <Form form={form}>
                <h3 style={{ marginBottom: "24px" }}>Бүтээгдэхүүн хуулах</h3>
                <Container>
                    <TopHead>
                        <SelectStore
                            form={form}
                            name="store"
                            setStores={setStores}
                            onChange={handleStore}
                        />
                    </TopHead>
                    {productList && Object.keys(productList).length > 0 && (
                        <Tabs
                            type="card"
                            activeKey={tabItem}
                            items={Object.keys(productList).map((field) => ({
                                label: field,
                                key: field,
                            }))}
                            onChange={onChangeTab}
                        />
                    )}

                    <Content>
                        <div className="from">
                            <Checkbox
                                indeterminate={indeterminateFrom}
                                onChange={onCheckAllChangeFrom}
                                checked={checkAllFrom}
                            >
                                Check all
                            </Checkbox>
                            <Divider />
                            <StyledCheckboxGroup
                                options={products}
                                value={checkedFromList}
                                onChange={onChangeFrom}
                            />
                        </div>
                        <div className="">
                            <Button
                                onClick={handleCopy}
                                disabled={
                                    checkedFromList.length === 0 || checkedToList.length === 0
                                }
                            >
                                Хуулах
                            </Button>
                        </div>
                        <div className="to">
                            <Checkbox
                                indeterminate={indeterminateTo}
                                onChange={onCheckAllChangeTo}
                                checked={checkAllTo}
                            >
                                Check all
                            </Checkbox>
                            <Divider />
                            <StyledCheckboxGroup
                                options={stores?.filter((item) => item !== store)}
                                value={checkedToList}
                                onChange={onChangeTo}
                            />
                        </div>
                    </Content>
                </Container>
            </Form>
        </StyledC>
    );
};

const Content = styled.div`
  display: flex;
  width: 100%;
  gap: 24px;
`;
const Container = styled.div`
  width: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const TopHead = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const StyledCheckboxGroup = styled(CheckboxGroup)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  label {
    margin: 0 !important;
  }
`;
const StyledC = styled.div`
  display: grid;
  gap: 24px;
  /* grid-template-columns: calc(50% - 12px) calc(50% - 12px); */
`;

export default ProductCopy;